import React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Box from "@mui/material/Box";
import SideDrawerStyles from "./SideDrawer.module.scss";

interface SideDrawerProps {
  isOpen: boolean;
  toggleDrawer: (open: boolean) => () => void;
  list?: () => React.ReactNode;
  onClose?: () => void;
}

export default function SideDrawer({
  isOpen,
  toggleDrawer,
  list,
  onClose,
}: SideDrawerProps) {
  return (
    <React.Fragment>
      <SwipeableDrawer
        className={SideDrawerStyles.myCustomDrawer}
        anchor="right"
        open={isOpen}
        onClose={onClose || (() => {})}
        onOpen={() => toggleDrawer(true)()}
        PaperProps={{
          sx: {
            // width: "365px",
            borderTopLeftRadius: 24,
            borderBottomLeftRadius: 24,
            overflow: "hidden",
            height: "100%",
            padding: 0,
          },
        }}
        ModalProps={{
          style: {
            position: "relative",
          },
          BackdropProps: {
            style: { backgroundColor: "transparent" },
          },
        }}
      >
        <Box sx={{ p: 2, height: "100%" }}>{list && list()}</Box>
      </SwipeableDrawer>
    </React.Fragment>
  );
}
